import ProductPageTemplate from "@/components/automacao/ProductPageTemplate";

const Atendimento = () => <ProductPageTemplate slug="atendimento" />;

export default Atendimento;
